import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideStates } from '@ngxs/store';
import { NotificationState } from './notification.state';
import { NotificationService } from './notification.service';

export function provideNotificationModule(): EnvironmentProviders {
    return makeEnvironmentProviders([provideStates([NotificationState]), NotificationService]);
}
